import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-semantics',
  templateUrl: './semantics.component.html',
  styleUrl: './semantics.component.scss',
})
export class SemanticsComponent {
  constructor(public analyticsService: AnalyticsService) {}
}
